import TaskManagement from '@/components/administration/TaskManagement';

const Tasks = () => {
  return <TaskManagement />;
};

export default Tasks;
